
import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { useDispatch } from 'react-redux';
import { viewImage } from '../../CommonUtils/viewImage';
import CommonStepperSection from '../Reports/CommonStepperSection';


export default function AfflClgRegistrationReport() {
    const acYear = sessionStorage.getItem('ac_year');
    const [statusObj, setStatusObj] = useState({});
    const [currentStep, setCurrentStep] = useState(0);
    const [allDone, setAllDone] = useState(false);

    const fieldToStepIndex = {
        approval: 0, application: 1, society: 2, clgdetails: 3, land: 4,
        geolocation: 5, bldrelated: 6, bldblocks: 7, instarea: 8, admarea: 9,
        clsroom: 10, coures: 11, acper: 12, tch: 13, nontch: 14,
        labarea: 15, labmap: 16, quip: 17, facilities: 18, infra: 19,
        finance: 20, fee: 21, affidavit: 22
    };

    const stepTitles = [
        "Approval", "Application", "Society", "College Details", "Society Land Allotments",
        "Geo Location", "College Building Related", "Building Blocks", "Instructional Area",
        "Administrative Area", "Class Room Area Calculation", "Course Intake", "Academic Performance",
        "Teaching Staff", "Non Teaching Staff", "Lab Area", "Lab course", "Lab Equipment",
        "College Facilities", "Other Infrastructural", "Financial Details", "Fee Status",
        "Affidavit Upload"
    ];

    function computeCurrentStep(status) {
        // Find the first step that's not done, otherwise mark all
        for (const [field, idx] of Object.entries(fieldToStepIndex)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return stepTitles.length;
    }



    function isAllDone(status) {
        return Object.keys(fieldToStepIndex).every(field => status[field] === 'Done');
    }


    function GetData() {
        const url = `${config.url.API_URL}getclgRegStatus`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === '01' && res.data.clgStatus?.[0]) {
                const obj = res.data.clgStatus[0];
                setStatusObj(obj);
                setCurrentStep(computeCurrentStep(obj));
                setAllDone(isAllDone(obj));
            } else {
                setStatusObj({});
                setCurrentStep(0);
                setAllDone(false);

            }
        }).catch(() => {
            setStatusObj({});
            setCurrentStep(0);
        });
    }



    const dispatch = useDispatch();

    const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');

    function GetPdf() {
        let payload = {}
        let url = config.url.API_URL + `getAffiliationPdf/` + userid + "/" + acYear;
        CommonAxiosPost(url, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }

    useEffect(() => { GetData(); }, []);

    return (
        // <>
        //     <CommonFormHeading heading={`College Application Status,AcYear ${acYear}`} />
        //     <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
        //         <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
        //             <h1 className='mb-0'>
        //                 College Name: <span>{statusObj?.inst_name}</span>
        //             </h1>
        //             <h1 className='mb-0 ms-4'>
        //                 College Code: <span>{statusObj?.coll_code}</span>
        //             </h1>
        //         </div>
        //         <bie.Container fluid className="pt-5 d-flex justify-content-center">
        //             <bie.Row>
        //                 <bie.Col md={12} className="px-4">
        //                     <div className="vertical-stepper" >
        //                         {stepTitles.map((title, i) => {
        //                             const stepIndex = i + 1;
        //                             const fieldName = Object.keys(fieldToStepIndex)
        //                                 .find(key => fieldToStepIndex[key] === i);
        //                             const val = statusObj[fieldName];
        //                             const isDone = val === 'Done';
        //                             const isActive = stepIndex === currentStep;
        //                             return (
        //                                 <div key={i} className="stepper-step d-flex mb-4">
        //                                     <div className="icon-column d-flex flex-column align-items-center">
        //                                         <div className={`step-circle ${isDone ? 'completed' : isActive ? 'active' : 'pending'}`}>
        //                                             {isDone ? <FaCheck /> : stepIndex}
        //                                         </div>
        //                                         {i < stepTitles.length - 1 && (
        //                                             <div className={`step-line ${stepIndex < currentStep ? 'line-completed' : ''}`}></div>
        //                                         )}
        //                                     </div>
        //                                     <button type='button'
        //                                         className="step-text ps-3"
        //                                         onClick={() => setCurrentStep(stepIndex)}
        //                                         style={{ cursor: 'pointer' }}
        //                                     >
        //                                         <div className={`step-label ${isDone ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}>
        //                                             {title}
        //                                         </div>
        //                                         <div className="step-status mt-1">
        //                                             <bie.Badge bg={isDone ? "success" : "danger"}>
        //                                                 {isDone
        //                                                     ? <><FaCheck className="me-1" /> Done</>
        //                                                     : <><FaTimes className="me-1" /> Not Done</>}
        //                                             </bie.Badge>

        //                                         </div>

        //                                     </button>

        //                                 </div>

        //                             );
        //                         })}
        //                     </div>
        //                 </bie.Col>
        //                 <center>
        //                     {allDone && (
        //                         <button
        //                             type="button"
        //                             className="btn btn-sm affl-print me-2"
        //                             onClick={GetPdf}>
        //                             click here to download  &emsp;<FaRegFilePdf size={20} />
        //                         </button>
        //                     )}
        //                 </center>

        //             </bie.Row>
        //         </bie.Container>
        //     </bie.Container>

        // </>
        <CommonStepperSection
            heading={`College Application Status,AcYear ${acYear}`}
            statusObj={statusObj}
            stepTitles={stepTitles}
            fieldToStepIndex={fieldToStepIndex}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            allDone={allDone}
            GetPdf={GetPdf}
        />
    );
}
